import { Button } from "@material-tailwind/react";
import PayPalCheckoutTutor from "../../../components/paypalCheckoutTutor";

export default function PaymentButton({ idx, item, itemIdx, buyNow }) {
  const { title, priceCad, attestati } = item;

  const validPrice = parseFloat(priceCad * attestati);
  const validCredits = parseInt(attestati);

  return (
    <div className="flex justify-center items-baseline flex-wrap mt-2 mb-2">
      <Button
        className="w-full content-center text-1xl"
        onClick={(e) => {
          e.preventDefault();
          buyNow(e, idx);
        }}
      >
        <div className="flex flex-col items-center w-full">
          <span>ACQUISTA CON BONIFICO</span>
          {itemIdx === idx && (
            <span className="text-xs">segui le indicazioni in basso</span>
          )}
        </div>
      </Button>

      <div className="mt-4 mb-2 text-sm w-full">oppure utilizza</div>

      {!isNaN(validPrice) && validCredits > 0 && (
        <PayPalCheckoutTutor
          key={`${idx}-${title}`}
          description={title}
          price={validPrice}
          credits={validCredits}
        />
      )}

      <div className="mt-0 mb-4 text-sm w-full">
        puoi pagare in 3 rate senza interessi
      </div>
    </div>
  );
}
